/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSaasCloudProvider } from './irrSaasCloudProvider';
import { IrrSddcConfig } from './irrSddcConfig';
import { IrrAuthorization } from './irrAuthorization';
import { IrrEdrConfig } from './irrEdrConfig';
import { IrrSaasCapabilities } from './irrSaasCapabilities';
import { IrrSaasConfigNetworks } from './irrSaasConfigNetworks';
import { IrrEmailConfig } from './irrEmailConfig';
import { IrrLoggingConfig } from './irrLoggingConfig';


/**
 * IRR SaaS Config Request specification
 */
export interface IrrSaasConfig { 
    capabilities?: IrrSaasCapabilities;
    cloudProvider?: IrrSaasCloudProvider;
    auth?: IrrAuthorization;
    network?: IrrSaasConfigNetworks;
    edrConfig?: IrrEdrConfig;
    sddcConfig?: Array<IrrSddcConfig>;
    email?: IrrEmailConfig;
    usage?: IrrLoggingConfig;
    logging?: IrrLoggingConfig;
}

